import {Component} from "react";
import React from "react";

import LoadingScreen from "../../includes/LoadingScreen";
import PageContent from "../../includes/PageContent";
import APIController from "../../controller/APIController";
import UserController from "../../controller/UserController";



import { Container} from "react-bootstrap";
import './SingleTopicPageForSupervisor.css'

import StatusBadge from "../../components/badges/StatusBadge";
import PradleAccordion from "../../components/PradleAccordion";


class SingleTopicsPageForSupervisor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFetching: true,
            topics: [],
            selectedProfessionId: props.params['professionId'],
            selectedTraineeId: props.params['traineeId'],
        }
        this.location = props.location;
        this.params = props.params;
    }

    async componentDidMount() {
        await this.reload()
    }

    async reload(){
        try {
            this.setState({
                isFetching: true
            })
            let trainee = null;
            let topicsResult = await APIController.getAllTopicsGroupedByProfessionId(this.state.selectedProfessionId,true);
            if(this.state.selectedTraineeId !== undefined){
                trainee = await APIController.getTraineeById(this.state.selectedTraineeId);
            }
            let worksheets = trainee ? trainee.worksheets : [];

            let allTopics = topicsResult[0].descriptions;
            let finishedTopics = allTopics.filter(topic =>
                worksheets.filter(ws => ws.state === APIController.WORKSHEET_STATES.GRADED_WORKING_SHEET ).some(ws => ws.topic === topic.topicId)
            );

            let runningTopics = allTopics.filter(topic =>
                worksheets.filter(ws => ws.state === APIController.WORKSHEET_STATES.OPEN_WORKING_SHEET ).some(ws => ws.topic === topic.topicId)
            );


            let otherTopics = allTopics.filter(topic =>
             !finishedTopics.some(ft => ft.topicId === topic.topicId)
             &&
             !runningTopics.some(ft => ft.topicId === topic.topicId)
            );

            this.setState({
                isFetching: false,
                professionName: topicsResult[0].professionName,
                allTopics: allTopics,
                trainee: trainee,
                worksheets: worksheets,
                finishedTopics: finishedTopics,
                runningTopics: runningTopics,
                otherTopics: otherTopics
            })
        } catch (e) {
            this.setState({
                isFetching: false,
                allTopics: [],
                trainee: null,
                worksheets: [],
                finishedTopics: [],
                runningTopics: [],
                otherTopics: [],
                professionName: ''
            })
        }
    }

    _renderTopicsRowsSimplified(topic, worksheetState = APIController.WORKSHEET_STATES.OPEN_WORKING_SHEET){
        if(topic.curriculumId){
        const ws = this.state.worksheets.filter(
        ws => ws.topic === topic.topicId && ws.state === worksheetState
        )[0]; //
        return(
            <tr className={(ws && ws.state == APIController.WORKSHEET_STATES.GRADED_WORKING_SHEET)?"ws-row":""} onClick={()=>{
                if(ws && ws.state == APIController.WORKSHEET_STATES.GRADED_WORKING_SHEET)window.location = "/worksheets/"+ws.id}}>
                <td style={{width:'6em'}}><span className={"topic"}>{topic.topicId}</span></td>
                <td style={{minWidth:'35em',textAlign:'left'}}>{topic.taskName}</td>
                <td style={{width:'12em',padding:'0.1em'}}>{topic.learningFieldId?
                    <span className={"badge"} style={{background:'rgb(0, 100, 114)',color:'white'}}>{topic.learningFieldId}</span>
                    :<span className={"badge"} style={{background:'red',color:'white'}}>nicht definiert</span>}
                </td>
                <td style={{minWidth:'12em',maxWidth:'35em'}}>{topic.curriculumId?
                    <span className={"badge"} style={{whiteSpace:'pre-wrap',maxWidth:'35em',textAlign:'left',color:'#444'}}>{topic.curriculumId}</span>
                    :<span className={"badge"} style={{background:'red',color:'white'}}>nicht definiert</span>}
                </td>
            </tr>
        )
        }else{
            return(<></>)
        }
    }




_renderTopicCards(topics, worksheetState = null) {
    const renderedYears = new Set();

    topics.sort((a, b) => a.topicId.localeCompare(b.topicId));

    return (
        <div>
            {topics.map((topic) => {
                const yearPrefix = topic.topicId.split('-')[0];
                const isFirstOfYear = !renderedYears.has(yearPrefix);

                if (isFirstOfYear) {
                    renderedYears.add(yearPrefix);
                }

                const ws = this.state.worksheets.filter(
                    ws => ws.topic === topic.topicId && ws.state === worksheetState
                )[0];
               if(!topic.curriculumId  || !topic.learningFieldId){
                    return <></>
                }
                return (
                    <React.Fragment key={topic.topicId}>

                        {/* YEAR HEADER */}
                        {isFirstOfYear && (
                            <div className="my-3">
                                <span className="badge bg-secondary p-2">
                                    {yearPrefix}. Ausbildungsjahr
                                </span>
                            </div>
                        )}

                        {/* CARD */}
                        <a className={(ws && ws.state == APIController.WORKSHEET_STATES.GRADED_WORKING_SHEET)?"ws-card":""}
                            onClick={()=>{
                if(ws && ws.state == APIController.WORKSHEET_STATES.GRADED_WORKING_SHEET)window.location = "/worksheets/"+ws.id}}
                            ><div className="card mb-2 shadow-sm border-0">
                            <div className="card-body">

                                {/* ID */}
                                <div className="mb-1">
                                    <span className="text-muted">{topic.topicId}</span>
                                </div>

                                {/* TITLE */}
                                <div className="mb-2">
                                    <strong>{topic.taskName}</strong>
                                </div>

                                {/* LERNFELD */}
                                <div className="mb-2">
                                    <small>Lernfeld Nr.:</small>{" "}
                                    {topic.learningFieldId ? (
                                        <span className="badge bg-info text-dark">
                                            {topic.learningFieldId}
                                        </span>
                                    ) : (
                                        <span className="badge bg-danger">
                                            nicht definiert
                                        </span>
                                    )}
                                </div>

                                {/* BERUFSFELD */}
                                <div className="mb-2">
                                    <small>Berufsfeld Nr.:</small>{" "}
                                    {topic.curriculumId ? (
                                        <span className="badge bg-dark text-wrap">
                                            {topic.curriculumId}
                                        </span>
                                    ) : (
                                        <span className="badge bg-danger">
                                            nicht definiert
                                        </span>
                                    )}
                                </div>

                                {/* STATUS */}
                                {worksheetState == StatusBadge.TYPES.GRADED_WORKING_SHEET.state && ws && (
                                    <div className="mt-2">
                                        <button
                                            className="btn btn-info"
                                            onClick={() => {
                                                if (
                                                    ws.state ===
                                                    StatusBadge.TYPES.GRADED_WORKING_SHEET.state
                                                ) {
                                                    window.location =
                                                        "/worksheets/" + ws.id;
                                                }
                                            }}
                                        >
                                            <StatusBadge
                                                onEvaluationUpdated={() => {}}
                                                changeable={false}
                                                smallSize={false}
                                                onWorksheetUpdated={() => {}}
                                                worksheet={ws}
                                            />
                                        </button>
                                    </div>
                                )}

                            </div>
                        </div></a>

                    </React.Fragment>
                );
            })}
        </div>
    );
}


    _renderTopicTable(topics, worksheetState = null){
        const renderedYears = new Set();
        topics.sort((a, b) => a.topicId.localeCompare(b.topicId));
        return(
             <table
                className="table table-striped allTopicsTable"
                style={{ tableLayout: 'fixed', width: '100%', overflowX: 'auto' }}
                >
                <tr className="header">
                    <td style={{ paddingLeft: '0.5em', width: '6em' }}>
                    <strong>ID</strong>
                    </td>
                    <td style={{ textAlign: 'left' }}>
                    <strong>Projekttitel</strong>
                    </td>
                    <td style={{ width: '6em', padding: '0.1em' }}>
                    <strong>Lernfeld Nr.</strong>
                    </td>
                    <td>
                    <strong>Berufsfeld Nr.</strong>
                    </td>
                </tr>

                {topics.map((topic, index) => {
                    const yearPrefix = topic.topicId.split('-')[0]; // "1", "2", ...
                    const isFirstOfYear = !renderedYears.has(yearPrefix);
                    if (isFirstOfYear) {
                    renderedYears.add(yearPrefix);
                    }
                    return (
                    <React.Fragment key={topic.topicId}>
                        {isFirstOfYear && (
                        <tr>
                            <td colSpan={worksheetState == null?4:4} style={{padding:'1em'}}>
                            <strong >{yearPrefix}. Ausbildungsjahr</strong>
                            </td>
                        </tr>
                        )}
                        {this._renderTopicsRowsSimplified(topic, worksheetState)}
                    </React.Fragment>
                    );
                })}
                </table>
        )
    }

    _renderTopicSection(id,title, open,worksheetState, topics){
        return(
             <PradleAccordion title={<h2>{title}</h2>}               
                keyId={id} open={open}>
                <>
                {/* DESKTOP TABLE */}
                <div className="d-none d-md-block">
                    {this._renderTopicTable(topics,worksheetState)}
                </div>

                {/* MOBILE CARDS */}
                <div className="d-md-none">
                    {this._renderTopicCards(topics,worksheetState)}
                </div>
                </>
            </PradleAccordion>
        )
    }


    _renderTraineeBubble(){
        return(
            <div className="col col-12 col-sm-12 col-lg-6 col-xl-4">
                <div className="traineeCard">
                <img style={{width:'50px'}} src={this.state.trainee.profileImage} />
                <h4 style={{display:'inline-block',marginLeft:'0.5em'}}>{this.state.trainee.firstname+ ' ' + this.state.trainee.name }</h4>
                <p style={{margin:0,marginTop:'0.5em'}}>
                                        <span className="cardtitle">Teilnehmer-Nr</span>
                                        <span className="cardValue">{this.state.trainee.externalId}</span><br />

                    <span className="cardtitle">Beruf</span> <span className="cardValue">{this.state.trainee.professionName}</span>
                </p>
                </div>
            </div>
        )
    }

    render() {
        var self = this;
        if (this.state.isFetching) {
            return <LoadingScreen>Projekte werden geladen</LoadingScreen>;
        }
            return (
                <div className={"SingleTopicsPageForSupervisor"}>
                    <PageContent>
                            <div>
                                    
                            <Container>
                                {this.state.trainee != null?
                                <>
                                    {this._renderTraineeBubble()}
                                    {this._renderTopicSection('running_topics',"Laufende Projekte",true,APIController.WORKSHEET_STATES.OPEN_WORKING_SHEET, this.state.runningTopics )}
                                    {this._renderTopicSection('finished_topics',"Abgeschlossene Projekte",true,APIController.WORKSHEET_STATES.GRADED_WORKING_SHEET, this.state.finishedTopics )}
                                    {this._renderTopicSection('other_topics',"Nicht durchgeführte Projekte",false, null, this.state.otherTopics )}
                                </>:
                                <>
                                    <h2>{this.state.professionName}</h2>

{/* Desktop */}
<div className="d-none d-md-block">
  {this._renderTopicTable(this.state.allTopics, null)}
</div>

{/* Mobile */}
<div className="d-md-none">
  {this._renderTopicCards(this.state.allTopics, null)}
</div>

                                </>
                                }
                        </Container>
                        </div>
                    </PageContent>
                </div>
            )

    }
}

export default SingleTopicsPageForSupervisor;